module.exports = __webpack_public_path__ + "static/media/_DSC1888.8e809316.jpg";